import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconGrowthTools: React.FC<SvgIconProps> = (props) => (
    <SvgIcon
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            d="M21.22 2.94C21.22 2.73 21.11 2.54 20.92 2.44C20.74 2.34 20.52 2.36 20.34 2.49L16.29 5.45C16.14 5.56 16.05 5.75 16.07 5.94C16.09 6.13 16.21 6.31 16.38 6.39L17.72 7.03L14.38 13.67L11.83 11.8C11.49 11.55 11.02 11.61 10.76 11.93L5.48999 18.18L3.62999 16.17C3.47999 16.01 3.28999 15.92 3.07999 15.91C3.06999 15.91 3.05999 15.91 3.04999 15.91C2.84999 15.91 2.66999 15.98 2.51999 16.12C2.35999 16.26 2.26999 16.46 2.25999 16.67C2.25999 16.88 2.32999 17.08 2.46999 17.24L4.93999 19.92C5.08999 20.08 5.29999 20.17 5.51999 20.17C5.75999 20.17 5.97999 20.06 6.11999 19.89L11.49 13.51L14.19 15.5C14.38 15.64 14.62 15.69 14.84 15.63C15.06 15.58 15.26 15.43 15.36 15.22L19.13 7.72L20.36 8.32C20.56 8.41 20.74 8.39 20.89 8.29C21.05 8.19 21.14 8.02 21.15 7.83L21.21 2.95L21.22 2.94Z"
            stroke="none"
            fill="currentColor"
        />
        <path
            d="M3.97 9.39C4.31 9.39 4.57 9.12 4.57 8.79C4.57 8.46 4.3 8.18 3.97 8.18C3.64 8.18 3.36 8.45 3.36 8.79C3.36 9.13 3.63 9.39 3.97 9.39Z"
            stroke="none"
            fill="currentColor"
        />
        <path
            d="M7.2 9.39C7.53 9.39 7.8 9.12 7.8 8.79C7.8 8.46 7.53 8.18 7.2 8.18C6.87 8.18 6.59 8.45 6.59 8.79C6.59 9.13 6.86 9.39 7.2 9.39Z"
            stroke="none"
            fill="currentColor"
        />
        <path
            d="M13.65 9.39C13.98 9.39 14.25 9.12 14.25 8.79C14.25 8.46 13.98 8.18 13.65 8.18C13.32 8.18 13.04 8.45 13.04 8.79C13.04 9.13 13.31 9.39 13.65 9.39Z"
            stroke="none"
            fill="currentColor"
        />
        <path
            d="M10.42 9.39C10.75 9.39 11.02 9.12 11.02 8.79C11.02 8.46 10.75 8.18 10.42 8.18C10.09 8.18 9.81 8.45 9.81 8.79C9.81 9.13 10.08 9.39 10.42 9.39Z"
            stroke="none"
            fill="currentColor"
        />
        <path
            d="M13.08 18.42C12.74 18.42 12.47 18.69 12.47 19.03C12.47 19.37 12.74 19.63 13.08 19.63C13.42 19.63 13.68 19.36 13.68 19.03C13.68 18.7 13.41 18.42 13.08 18.42Z"
            stroke="none"
            fill="currentColor"
        />
        <path
            d="M9.84999 18.42C9.50999 18.42 9.23999 18.69 9.23999 19.03C9.23999 19.37 9.50999 19.63 9.84999 19.63C10.19 19.63 10.45 19.36 10.45 19.03C10.45 18.7 10.18 18.42 9.84999 18.42Z"
            stroke="none"
            fill="currentColor"
        />
        <path
            d="M16.31 18.42C15.97 18.42 15.7 18.69 15.7 19.03C15.7 19.37 15.97 19.63 16.31 19.63C16.65 19.63 16.91 19.36 16.91 19.03C16.91 18.7 16.64 18.42 16.31 18.42Z"
            stroke="none"
            fill="currentColor"
        />
    </SvgIcon>
)
